document.addEventListener('DOMContentLoaded', () => {
  const carousel = document.querySelector('.moko-tracker-feature-carousel');
  if (!carousel) return;

  const track = carousel.querySelector('.moko-tracker-feature-carousel__track');
  const prevBtn = carousel.querySelector('[data-direction="prev"]');
  const nextBtn = carousel.querySelector('[data-direction="next"]');

  if (!track || !prevBtn || !nextBtn) return;

  const getSlideWidth = () => {
    const firstSlide = track.querySelector('.moko-tracker-feature-carousel__slide');
    if (!firstSlide) return 0;
    const gap = parseFloat(getComputedStyle(track).gap) || 0;
    return firstSlide.offsetWidth + gap;
  };

  const updateArrowStates = () => {
    const maxScroll = track.scrollWidth - track.clientWidth;
    prevBtn.disabled = track.scrollLeft <= 1;
    nextBtn.disabled = track.scrollLeft >= maxScroll - 1;
  };

  prevBtn.addEventListener('click', () => {
    track.scrollBy({ left: -getSlideWidth(), behavior: 'smooth' });
  });

  nextBtn.addEventListener('click', () => {
    track.scrollBy({ left: getSlideWidth(), behavior: 'smooth' });
  });

  track.addEventListener('scroll', updateArrowStates, { passive: true });

  const initArrows = () => {
    requestAnimationFrame(() => {
      updateArrowStates();
    });
  };

  window.addEventListener('load', initArrows);
  initArrows();
});
